import React from 'react'
import { StyleSheet } from 'react-native'

import { WhereToOverlayProps } from './types'

import { WhereTo } from '../WhereTo/WhereTo'

export const WhereToOverlay = ({
  combinedCategoriesAndProgramIds,
  creator,
  bottomSheetRef,
}: WhereToOverlayProps): JSX.Element => {
  const styles = StyleSheet.create({
    container: {
      position: 'absolute',
      left: 16,
      top: 16,
      paddingVertical: 6,
      paddingHorizontal: 8,
      borderRadius: 5,
      backgroundColor: 'rgba(169, 169, 169, 0.5)',
      maxWidth: '40%',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 3,
      'backdrop-filter': 'blur(2px)',
    },
  })

  return (
    <WhereTo
      creator={creator}
      combinedCategoriesAndProgramIds={combinedCategoriesAndProgramIds}
      bottomSheetRef={bottomSheetRef}
      containerStyle={styles.container}
    />
  )
}
